import React, { useState, useEffect } from 'react';

import { addDoc, collection } from "firebase/firestore";
import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";
import db, { storage } from "./Firebase";
import { doc, setDoc, getDocs } from "firebase/firestore";
import ViewAllCourses from './ViewAllCourses';
import axios from 'axios';
import SideMenu from './SideMenu';

const CourseUploadForm = () => {
    const [formData, setFormData] = useState({
        course_name: '',
        course_description: '',
        actual_price: '',
        membership_price: '',
        lessons: [
            {
                lesson: '',
                description: '',
                video_link: '',
                timestamps: [],
                is_completed: 'no',
                is_video: 'no',
                is_online: 'no',
                notes_drive_link: '',
                sequence: '',
                time: '',
                title: '',
                worksheet: '',
                zoom_date_time: '',
                zoom_link: '',
                completion_percentage: '0%',
            }
        ],
    });



    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const [courses, setCourses] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchCourses = async () => {
            try {
                const querySnapshot = await getDocs(collection(db, "nv_courses"));
                const courseData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setCourses(courseData);
            } catch (error) {
                console.error("Error fetching courses:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchCourses();
    }, []);

    const addLesson = () => {
        setFormData((prev) => ({
            ...prev,
            lessons: [...prev.lessons, {
                lesson: '',
                description: '',
                video_link: '',
                timestamps: [],
                is_completed: 'no',
                is_video: 'no',
                is_online: 'no',
                notes_drive_link: '',
                sequence: '',
                time: '',
                title: '',
                worksheet: '',
                zoom_date_time: '',
                zoom_link: '',
                completion_percentage: '0%',
            }],
        }));
    };



    const [experts, setExperts] = useState([]);
    const [expert_name, setExpert_name] = useState([]);
    const [expert_image, setExpert_image] = useState([]);

    const [isEditing, setIsEditing] = useState(false);
    const [editCourseId, setEditCourseId] = useState(null);



    useEffect(() => {
        const fetchExperts = async () => {
            try {
                const querySnapshot = await getDocs(collection(db, "nv_expert_details"));
                setExperts(querySnapshot.docs.map((doc) => ({
                    id: doc.id,
                    name: doc.data().name || "Unnamed Expert"
                })));
                setExpert_name(querySnapshot.docs.map((doc) => ({
                    name: doc.data().name || "Unnamed Expert"
                })));
                setExpert_image(querySnapshot.docs.map((doc) => ({
                    id: doc.id,
                    name: doc.data().name || "Unnamed Expert",
                    profile_image: doc.data().profile_image || "Unnamed Expert"
                })));
            } catch (error) {
                console.error("Error fetching experts: ", error);
            }
        };

        fetchExperts();
    }, []);

    const handleLessonChange = (lessonIndex, e) => {
        const { name, value } = e.target;
        const updatedLessons = [...formData.lessons];
        updatedLessons[lessonIndex] = {
            ...updatedLessons[lessonIndex],
            [name]: value
        };
        setFormData({ ...formData, lessons: updatedLessons });
    };

    const addTimestamp = (lessonIndex) => {
        const updatedLessons = [...formData.lessons];
        updatedLessons[lessonIndex].timestamps.push({ time: '', title: '' });
        setFormData((prev) => ({ ...prev, lessons: updatedLessons }));
    };

    const handleTimestampChange = (lessonIndex, timestampIndex, e) => {
        const { name, value } = e.target;
        const updatedLessons = [...formData.lessons];
        updatedLessons[lessonIndex].timestamps[timestampIndex][name] = value;
        setFormData({ ...formData, lessons: updatedLessons });
    };

    const handleVideoUpload = (lessonIndex, file) => {
        if (!file) return;

        const storageRef = ref(storage, `nv_courses/videos/${file.name}`);
        const uploadTask = uploadBytesResumable(storageRef, file);

        uploadTask.on(
            "state_changed",
            (snapshot) => {
                const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                console.log(`Upload is ${progress}% done`);
            },
            (error) => {
                console.error("Upload failed", error);
            },
            async () => {
                const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
                const updatedLessons = [...formData.lessons];
                updatedLessons[lessonIndex].video_link = downloadURL;
                setFormData((prev) => ({ ...prev, lessons: updatedLessons }));
                alert("Video uploaded successfully!");
            }
        );
    };


    const toDatetimeInputFormat = (val) => {
        if (!val) return ''; // null or undefined

        try {
            // Firestore Timestamp (has toDate method)
            if (typeof val === 'object' && typeof val.toDate === 'function') {
                const date = val.toDate();
                return date.toISOString().slice(0, 16);
            }

            // If it's a string or Date
            const date = new Date(val);
            if (!isNaN(date.getTime())) {
                return date.toISOString().slice(0, 16);
            }

            return ''; // fallback for unrecognized format
        } catch (error) {
            console.warn('Invalid date value:', val, error);
            return '';
        }
    };



    const handleEdit = (course) => {
        const normalizedLessons = (course.lessons || []).map((lesson) => ({
            ...lesson,
            timestamps: lesson.timestamps || lesson.timestamp || [],
            start_on: toDatetimeInputFormat(lesson.start_on),
            end_on: toDatetimeInputFormat(lesson.end_on),
        }));

        setFormData({
            ...course,
            actual_price: course.course_price?.actual_price || '',
            membership_price: course.course_price?.membership_price || '',
            lessons: normalizedLessons
        });

        setIsEditing(true);
        setEditCourseId(course.id);
    };







    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            // Fetch existing documents from the 'nv_courses' collection
            const querySnapshot = await getDocs(collection(db, 'nv_courses'));

            // Determine the new document ID based on existing count
            const docCount = querySnapshot.size;  // Get number of documents (currently 4)


            // Extract numeric parts of document IDs

            // Extract numeric parts of document IDs
            const existingIds = querySnapshot.docs
                .map((doc) => parseInt(doc.id, 10)) // Convert IDs to numbers
                .filter((id) => !isNaN(id)) // Remove NaN values
                .sort((a, b) => a - b); // Sort in ascending order

            // Find the first available ID in sequence
            let nextDocId = 1; // Start from "001"
            for (let id of existingIds) {
                if (id !== nextDocId) break; // Find first missing ID in sequence
                nextDocId++;
            }

            // Format as "003", "004", etc.
            const formattedDocId = String(nextDocId).padStart(3, '0');

            const finalData = {
                all_course_notes: formData.all_course_notes || "",
                all_course_notes_link: formData.all_course_notes_link || "",
                content_description: formData.content_description || "",
                course_categories: formData.course_categories || "",
                course_description: formData.course_description || "",
                course_end_date: formData.course_end_date || new Date(),
                course_expert_name: formData.course_expert_name || "",
                course_id: isEditing ? editCourseId : formattedDocId,
                course_image: formData.course_image || "",
                course_language: formData.course_language || "Hindi/English",
                course_length: formData.course_length || "",
                course_name: formData.course_name || "",
                course_price: {
                    actual_price: parseInt(formData.actual_price) || 0,
                    membership_price: parseInt(formData.membership_price) || 0
                },
                course_start_date: formData.course_start_date || new Date(),
                course_tag: formData.course_categories || "",
                course_type: formData.course_type || "",
                created_date: new Date(),
                demo_video_url: formData.demo_video_url || "",
                expert_id: formData.expert_id || "",
                expert_image_url: formData.expert_image_url || "",
                is_certificate: formData.is_certificate || "no",
                is_demo_video: formData.is_demo_video || "no",
                is_doubt_clearing_session: formData.is_doubt_clearing_session || "no",
                is_pdfnotes: formData.is_pdfnotes || "no",
                is_quiz: formData.is_quiz || "false",
                is_recording: formData.is_recording || "no",
                is_whatsappgroup: formData.is_whatsappgroup || "no",
                lessons: formData.lessons.map((lesson, index) => ({
                    lesson: lesson.lesson || "",
                    description: lesson.description || "",
                    video_link: lesson.video_link || "",
                    start_on: lesson.start_on ? new Date(lesson.start_on) : null,
                    end_on: lesson.end_on ? new Date(lesson.end_on) : null,
                    is_completed: "no",
                    is_file: lesson.is_file || "no",
                    is_online: lesson.is_online || "no",
                    is_video: lesson.is_video || "no",
                    notes: lesson.notes || "",
                    sequence: `${index + 1}`,
                    time: lesson.time || "",
                    title: lesson.title || "",
                    worksheet: lesson.worksheet || "",
                    zoom_date_time: lesson.zoom_date_time || "",
                    zoom_link: lesson.zoom_link || "",
                    completion_percentage: "0%",
                    timestamp: lesson.timestamps?.map(timestamp => ({
                        time: timestamp.time || "",
                        title: timestamp.title || "",
                    })) || []
                })),
                overall_completion_percentage: 0,
                passing_marks: parseInt(formData.passing_marks) || 0,
                quiz_id: formData.quiz_id || "",
                registered_date: new Date(),
                total_quiz_questions: parseInt(formData.total_quiz_questions) || 0,
                updated_date: new Date()
            };

            // Save document with the custom generated ID
            // await setDoc(doc(db, 'nv_courses', formattedDocId), finalData);
            if (isEditing) {
                await setDoc(doc(db, 'nv_courses', editCourseId), finalData);
                alert(`Course updated successfully: ${editCourseId}`);
            } else {
                await setDoc(doc(db, 'nv_courses', formattedDocId), finalData);
                alert(`Course uploaded successfully with ID: ${formattedDocId}`);
            }
            console.log(formattedDocId)
            console.log(finalData)

            const response = await axios.post('http://54.95.81.249:5000/send-global-notification', {
                "title": "New Course Alert! Register Now!",
                "body": "A fresh course is here to help you level up! Register now and get started!",
                "image": formData.course_image, // Optional image URL,
            });


            alert(`Course uploaded successfully with ID: ${formattedDocId}`);
        } catch (error) {
            console.error("Error uploading course:", error);
            alert('Error uploading course.');
        }
    };



    const [sidebarOpen, setSidebarOpen] = useState(false);




    return (
        <>
            <SideMenu onToggle={setSidebarOpen} />
            <div className={`main-content ${sidebarOpen ? "shifted" : ""}`}>
                <div class="p-3">
                    <table className="table table-bordered table-hover">
                        <thead className="thead-dark" style={{ position: "sticky", top: "0" }}>
                            <tr>
                                <th>Course ID</th>
                                <th>Name</th>
                                <th>Course Categories</th>
                                <th>Course Type</th>
                                <th>Start Date</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {courses.map(course => (
                                <tr key={course.id}>
                                    <td>{course.course_id}</td>
                                    <td>{course.course_name}</td>
                                    <td>{course.course_categories || "N/A"}</td>
                                    <td>{course.course_type || "N/A"}</td>
                                    <td>{course.course_start_date || "N/A"}</td>
                                    <td><button onClick={() => handleEdit(course)}>Edit</button></td>

                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div id="" class="m-3" style={{ border: "10px solid #344767" }}>
                    <div class="w3layouts_payment_online_form">
                        <h4>Upload Course</h4>
                        <form onSubmit={handleSubmit}>

                            <ul style={{ display: "flex" }}>
                                <li><label>course_name</label><input class="w3l_text_box" name="course_name" placeholder="course_name" onChange={handleChange} value={formData.course_name} /></li>
                                <li><label>course_description</label><textarea rows="4" cols="50" class="w3l_text_box" name="course_description" placeholder="course_description" value={formData.course_description} onChange={handleChange} /></li>
                            </ul>

                            <ul>
                                <li><label>course image</label><input class="w3l_text_box" name="course_image" value={formData.course_image} placeholder="Course Image URL" onChange={handleChange} /></li>
                                <li><label>demo_video_url</label><input class="w3l_text_box" name="demo_video_url" value={formData.demo_video_url} placeholder="demo_video_url" onChange={handleChange} /></li>
                            </ul>

                            <ul>
                                <li><label>actual_price</label><input class="w3l_text_box" name="actual_price" value={formData.actual_price} placeholder="actual_price" onChange={handleChange} /></li>
                                <li><label>membership_price</label><input class="w3l_text_box" name="membership_price" value={formData.membership_price} placeholder="membership_price" onChange={handleChange} /></li>
                            </ul>



                            <ul>
                                <li> <label>all_course_notes</label><select class="form-control" name="all_course_notes" value={formData.all_course_notes} onChange={handleChange} >
                                    <option value="">-- All Course Notes --</option>
                                    <option value="yes">yes</option>
                                    <option value="no">no</option>
                                </select></li>
                                <li><label>all_course_notes_link</label><input class="w3l_text_box" name="all_course_notes_link" value={formData.all_course_notes_link} placeholder="all_course_notes_link" onChange={handleChange} /></li>

                            </ul>

                            <ul>
                                <li> <label>course type</label><select class="form-control" name="course_type" value={formData.course_type} onChange={handleChange} >
                                    <option value="">-- course_type --</option>
                                    <option value="Recorded">Recorded</option>
                                    <option value="Live">Live</option>
                                </select></li>

                                <li><label>course length (eg. 1 hr 32 mins / 3 Days)</label><input class="w3l_text_box" name="course_length" value={formData.course_length} placeholder="Course Length" onChange={handleChange} /></li>

                            </ul>

                            <ul>
                                <li><label>Content Description (eg. 2 Recorded Classes/ 5 Live Classes) </label><input class="w3l_text_box" name="content_description" value={formData.content_description} placeholder="content_description" onChange={handleChange} /></li>

                                <li><label>course_expert_name</label>
                                    <select className="form-control" name="course_expert_name" value={formData.course_expert_name} onChange={handleChange}>
                                        <option value="">Select Expert Name</option>
                                        {expert_name.map(({ name }) => (
                                            <option key={name} value={name}>{`${name}`}</option>
                                        ))}
                                    </select>
                                </li>
                            </ul>






                            <ul>

                                <li><label>course_categories</label><input class="w3l_text_box" name="course_categories" value={formData.course_categories} placeholder="course_categories" onChange={handleChange} /></li>
                            </ul>


                            <ul>
                                <li><label>Course Start Date (required)</label>
                                    <input
                                        type="date"
                                        name="course_start_date"
                                        onChange={handleChange}
                                        required
                                        value={formData.course_start_date}

                                    /></li>
                                <li><label>Course End Date (required)</label>
                                    <input
                                        type="date"
                                        name="course_end_date"
                                        value={formData.course_end_date}
                                        onChange={handleChange}
                                        required
                                    /></li>
                            </ul>



                            <ul>

                                <li>
                                    <label>expert_id</label>
                                    <select className="form-control" name="expert_id" value={formData.expert_id} onChange={handleChange}>
                                        <option value="">Select Expert ID</option>
                                        {experts.map(({ id, name }) => (
                                            <option key={id} value={id}>{`${id} - ${name}`}</option>
                                        ))}
                                    </select>
                                </li>
                                <li><label>expert_image_url</label>
                                    <select className="form-control" name="expert_image_url" value={formData.expert_image_url} onChange={handleChange}>
                                        <option value="">Select Expert Image</option>
                                        {expert_image.map(({ profile_image, id, name }) => (
                                            <option key={profile_image} value={profile_image}>{`${id} - ${name}`}</option>
                                        ))}
                                    </select>

                                </li>
                            </ul>


                            <ul>
                                <li> <label>is_certificate</label><select class="form-control" name="is_certificate" value={formData.is_certificate} onChange={handleChange} >
                                    <option value="">-- is_certificate --</option>
                                    <option value="yes">yes</option>
                                    <option value="no">no</option>
                                </select></li>

                                <li> <label>is_demo_video</label><select class="form-control" name="is_demo_video" value={formData.is_demo_video} onChange={handleChange} >
                                    <option value="">-- is_demo_video --</option>
                                    <option value="yes">yes</option>
                                    <option value="no">no</option>
                                </select></li>
                            </ul>


                            <ul>
                                <li> <label>is_doubt_clearing_session</label><select class="form-control" name="is_doubt_clearing_session" value={formData.is_doubt_clearing_session} onChange={handleChange} >
                                    <option value="">-- is_doubt_clearing_session --</option>
                                    <option value="yes">yes</option>
                                    <option value="no">no</option>
                                </select></li>

                                <li> <label>is_pdfnotes</label><select class="form-control" name="is_pdfnotes" value={formData.is_pdfnotes} onChange={handleChange} >
                                    <option value="">-- is_pdfnotes --</option>
                                    <option value="yes">yes</option>
                                    <option value="no">no</option>
                                </select></li>
                            </ul>


                            <ul>
                                <li> <label>is_recording</label><select class="form-control" name="is_recording" value={formData.is_recording} onChange={handleChange} >
                                    <option value="">-- is_recording --</option>
                                    <option value="yes">yes</option>
                                    <option value="no">no</option>
                                </select></li>

                                <li> <label>is_whatsappgroup</label><select class="form-control" name="is_whatsappgroup" value={formData.is_whatsappgroup} onChange={handleChange} >
                                    <option value="">-- is_whatsappgroup --</option>
                                    <option value="yes">yes</option>
                                    <option value="no">no</option>
                                </select></li>





                            </ul>



                            <ul>
                                <li> <label>is_quiz</label><select class="form-control" name="is_quiz" value={formData.is_quiz} onChange={handleChange} >
                                    <option value="">-- is_quiz --</option>
                                    <option value="true">true</option>
                                    <option value="false">false</option>
                                </select></li>

                                <li><label>quiz_id</label><input class="w3l_text_box" name="quiz_id" placeholder="quiz_id" value={formData.quiz_id} onChange={handleChange} /></li>

                            </ul>

                            <ul>
                                <li><label>passing_marks</label><input class="w3l_text_box" name="passing_marks" value={formData.passing_marks} type="number" placeholder="passing_marks" onChange={handleChange} /></li>
                                <li><label>total_quiz_questions</label><input class="w3l_text_box" name="total_quiz_questions" value={formData.total_quiz_questions} placeholder="total_quiz_questions" onChange={handleChange} /></li>

                            </ul>





                            <h4>Add Lessons</h4>
                            {formData.lessons.map((lesson, lessonIndex) => (
                                <div key={lessonIndex} style={{ marginBottom: "20px" }}>

                                    <ul>


                                        <li> <label>is_video</label><select class="form-control" name="is_video" value={lesson.is_video} onChange={(e) => handleLessonChange(lessonIndex, e)} >
                                            <option value="">-- is_file --</option>
                                            <option value="yes">yes</option>
                                            <option value="no">no</option>
                                        </select></li>
                                        <li> <label>video_link/module (youtube ID)</label><input class="w3l_text_box" name="video_link" value={lesson.video_link} placeholder="video_link" onChange={(e) => handleLessonChange(lessonIndex, e)} /></li>
                                    </ul>

                                    <ul>
                                        <li> <label>is_Live</label><select class="form-control" name="is_online" value={lesson.is_online} onChange={(e) => handleLessonChange(lessonIndex, e)} >
                                            <option value="">-- is_live --</option>
                                            <option value="yes">yes</option>
                                            <option value="no">no</option>
                                        </select></li>
                                        <li><label>time (if Live)</label><input class="w3l_text_box" name="time" value={lesson.time} placeholder="time" onChange={(e) => handleLessonChange(lessonIndex, e)} /></li>
                                    </ul>


                                    <ul>
                                        <li><label>zoom_date_time (if live)</label><input class="w3l_text_box" name="zoom_date_time" placeholder="zoom_date_time" value={lesson.zoom_date_time} onChange={(e) => handleLessonChange(lessonIndex, e)} /></li>
                                        <li><label>zoom_link (if Live)</label><input class="w3l_text_box" name="zoom_link" placeholder="zoom_link" value={lesson.zoom_link} onChange={(e) => handleLessonChange(lessonIndex, e)} /></li>
                                    </ul>




                                    <ul>
                                        <li>  <label>Lesson/Module Name</label>
                                            <input class="w3l_text_box" name="lesson" placeholder="lesson" value={lesson.lesson} onChange={(e) => handleLessonChange(lessonIndex, e)} /></li>
                                        <li><label>title</label><input class="w3l_text_box" name="title" value={lesson.title} placeholder="title" onChange={(e) => handleLessonChange(lessonIndex, e)} /></li>
                                    </ul>


                                    <label>Description</label>
                                    <input class="w3l_text_box" name="description" placeholder="description" value={lesson.description} onChange={(e) => handleLessonChange(lessonIndex, e)} />






                                    <ul>
                                        <li>
                                            <label>Starts on (if Live)</label>
                                            <input
                                                type="datetime-local"
                                                name="start_on"
                                                onChange={(e) => handleLessonChange(lessonIndex, e)}
                                                value={lesson.start_on} // Format for datetime-local
                                            />
                                        </li>
                                        <li>
                                            <label>Ends on (if Live)</label>
                                            <input
                                                type="datetime-local"
                                                name="end_on"
                                                onChange={(e) => handleLessonChange(lessonIndex, e)}
                                                value={lesson.end_on} // Format for datetime-local
                                            />
                                        </li>
                                    </ul>






                                    <ul>
                                        <li><label>notes drive link</label><input class="w3l_text_box" name="notes" placeholder="notes drive link" value={lesson.notes} onChange={(e) => handleLessonChange(lessonIndex, e)} /></li>
                                        <li><label>worksheet (drive link)</label><input class="w3l_text_box" name="worksheet" value={lesson.worksheet} placeholder="worksheet" onChange={(e) => handleLessonChange(lessonIndex, e)} /></li>

                                    </ul>



                                    <ul>


                                    </ul>








                                    <button class="w3_payment_sendbtns" type="button" onClick={() => addTimestamp(lessonIndex)}>Add Timestamp</button>
                                    {lesson.timestamps.map((timestamp, timestampIndex) => (
                                        <div key={timestampIndex} style={{ marginBottom: "10px" }}>
                                            <ul>
                                                <li>  <input
                                                    name="time"
                                                    placeholder="Time"
                                                    onChange={(e) => handleTimestampChange(lessonIndex, timestampIndex, e)}
                                                    value={timestamp.time}

                                                /></li>
                                                <li> <input
                                                    name="title"
                                                    placeholder="Title"
                                                    onChange={(e) => handleTimestampChange(lessonIndex, timestampIndex, e)}
                                                    value={timestamp.title}

                                                /></li>
                                            </ul>


                                        </div>
                                    ))}

                                    <hr
                                        style={{
                                            backgroundColor: "red",
                                            height: 5
                                        }}
                                    />
                                </div>
                            ))}
                            <button class="btn btn-warning mr-4" type="button" onClick={addLesson}>Add Lesson</button>


                            <button class="btn btn-primary" type="submit"> {isEditing ? "Update Course" : "Upload Course"}</button>
                        </form>
                    </div>
                </div></div>
        </>
    );
};

export default CourseUploadForm;




// import React, { useState, useEffect } from 'react';

// import { addDoc, collection } from "firebase/firestore";
// import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";
// import db, { storage } from "./Firebase";
// import { doc, setDoc, getDocs } from "firebase/firestore";
// import ViewAllCourses from './ViewAllCourses';
// import axios from 'axios';

// const CourseUploadForm = () => {
//     const [formData, setFormData] = useState({
//         course_name: '',
//         course_description: '',
//         actual_price: '',
//         membership_price: '',
//         lessons: [
//             {
//                 lesson_data: '',
//                 description: '',
//                 video_link: '',
//                 timestamps: [],
//                 is_completed: 'no',
//                 is_video: 'no',
//                 is_online: 'no',
//                 notes_drive_link: '',
//                 sequence: '',
//                 time: '',
//                 title: '',
//                 worksheet: '',
//                 zoom_date_time: '',
//                 zoom_link: '',
//                 completion_percentage: '0%',
//             }
//         ],
//     });


//     // useEffect(() => {
//     //     const fetchDocIds = async () => {
//     //         try {
//     //             const querySnapshot = await getDocs(collection(db, "nv_expert_details"));
//     //             const ids = querySnapshot.docs.map((doc) => doc.id);
//     //             // setDocIds(ids);
//     //         } catch (error) {
//     //             console.error("Error fetching document IDs: ", error);
//     //         }
//     //     };

//     //     fetchDocIds();
//     // }, []);

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormData((prev) => ({
//             ...prev,
//             [name]: value,
//         }));
//     };

//     const [courses, setCourses] = useState([]);
//     const [loading, setLoading] = useState(true);

//     useEffect(() => {
//         const fetchCourses = async () => {
//             try {
//                 const querySnapshot = await getDocs(collection(db, "nv_courses"));
//                 const courseData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
//                 setCourses(courseData);
//             } catch (error) {
//                 console.error("Error fetching courses:", error);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchCourses();
//     }, []);

//     const addLesson = () => {
//         setFormData((prev) => ({
//             ...prev,
//             lessons: [...prev.lessons, {
//                 lesson_data: '',
//                 description: '',
//                 video_link: '',
//                 timestamps: [],
//                 is_completed: 'no',
//                 is_video: 'no',
//                 is_online: 'no',
//                 notes_drive_link: '',
//                 sequence: '',
//                 time: '',
//                 title: '',
//                 worksheet: '',
//                 zoom_date_time: '',
//                 zoom_link: '',
//                 completion_percentage: '0%',
//             }],
//         }));
//     };

//     // const handleLessonChange = (index, e) => {
//     //     const { name, value } = e.target;
//     //     const updatedLessons = [...formData.lessons];
//     //     updatedLessons[index][name] = value;
//     //     setFormData((prev) => ({ ...prev, lessons: updatedLessons }));
//     // };

//     const [experts, setExperts] = useState([]);
//     const [expert_name, setExpert_name] = useState([]);
//     const [expert_image, setExpert_image] = useState([]);


//     useEffect(() => {
//         const fetchExperts = async () => {
//             try {
//                 const querySnapshot = await getDocs(collection(db, "nv_expert_details"));
//                 setExperts(querySnapshot.docs.map((doc) => ({
//                     id: doc.id,
//                     name: doc.data().name || "Unnamed Expert"
//                 })));
//                 setExpert_name(querySnapshot.docs.map((doc) => ({
//                     name: doc.data().name || "Unnamed Expert"
//                 })));
//                 setExpert_image(querySnapshot.docs.map((doc) => ({
//                     id: doc.id,
//                     name: doc.data().name || "Unnamed Expert",
//                     profile_image: doc.data().profile_image || "Unnamed Expert"
//                 })));
//             } catch (error) {
//                 console.error("Error fetching experts: ", error);
//             }
//         };

//         fetchExperts();
//     }, []);

//     const handleLessonChange = (lessonIndex, e) => {
//         const { name, value } = e.target;
//         const updatedLessons = [...formData.lessons];
//         updatedLessons[lessonIndex] = {
//             ...updatedLessons[lessonIndex],
//             [name]: value
//         };
//         setFormData({ ...formData, lessons: updatedLessons });
//     };

//     const addTimestamp = (lessonIndex) => {
//         const updatedLessons = [...formData.lessons];
//         updatedLessons[lessonIndex].timestamps.push({ time: '', title: '' });
//         setFormData((prev) => ({ ...prev, lessons: updatedLessons }));
//     };

//     const handleTimestampChange = (lessonIndex, timestampIndex, e) => {
//         const { name, value } = e.target;
//         const updatedLessons = [...formData.lessons];
//         updatedLessons[lessonIndex].timestamps[timestampIndex][name] = value;
//         setFormData({ ...formData, lessons: updatedLessons });
//     };

//     const handleVideoUpload = (lessonIndex, file) => {
//         if (!file) return;

//         const storageRef = ref(storage, `nv_courses/videos/${file.name}`);
//         const uploadTask = uploadBytesResumable(storageRef, file);

//         uploadTask.on(
//             "state_changed",
//             (snapshot) => {
//                 const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
//                 console.log(`Upload is ${progress}% done`);
//             },
//             (error) => {
//                 console.error("Upload failed", error);
//             },
//             async () => {
//                 const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
//                 const updatedLessons = [...formData.lessons];
//                 updatedLessons[lessonIndex].video_link = downloadURL;
//                 setFormData((prev) => ({ ...prev, lessons: updatedLessons }));
//                 alert("Video uploaded successfully!");
//             }
//         );
//     };

//     // const handleSubmit = async (e) => {
//     //     e.preventDefault();
//     //     // try {
//     //     //     await addDoc(collection(db, 'nv_courses'), formData);
//     //     //     alert('Course uploaded successfully!');
//     //     // } catch (error) {
//     //     //     console.error('Error uploading course:', error);
//     //     // }
//     //     console.log(formData);
//     // };
//     // const handleSubmit = async (e) => {
//     //     e.preventDefault();

//     //     const finalData = {
//     //         ...formData,
//     //         created_date: new Date().toISOString(),
//     //         overall_completion_percentage: 0,
//     //         registered_date: new Date().toISOString(),
//     //         updated_date: new Date().toISOString(),
//     //         course_language: "Hindi/English",
//     //         course_price: {
//     //             actual_price: formData.actual_price,
//     //             membership_price: formData.membership_price
//     //         },
//     //     };

//     //     console.log(formData)
//     //     console.log(finalData)

//     //     await addDoc(collection(db, 'nv_courses'), finalData);
//     //     alert('Course uploaded successfully!');
//     // };


//     // const handleSubmit = async (e) => {
//     //     e.preventDefault();

//     //     // Clean up lessons by removing empty fields
//     //     const cleanedLessons = formData.lessons.map(lesson => {
//     //         return Object.fromEntries(
//     //             Object.entries(lesson).filter(([_, value]) => value !== "")
//     //         );
//     //     });

//     //     const finalData = {
//     //         // ...formData,
//     //         // lessons: cleanedLessons,
//     //         // created_date: new Date().toISOString(),
//     //         // registered_date: new Date().toISOString(),
//     //         // updated_date: new Date().toISOString(),
//     //         // overall_completion_percentage: 0,
//     //         // course_language: "Hindi/English",
//     //         // course_price: {
//     //         //     actual_price: formData.actual_price || 0,
//     //         //     membership_price: formData.membership_price || 0
//     //         // },
//     //     };

//     //     console.log(formData)
//     //     console.log(finalData)

//     //     try {
//     //         await addDoc(collection(db, 'nv_courses'), finalData);
//     //         alert('Course uploaded successfully!');
//     //     } catch (error) {
//     //         console.error("Error uploading course:", error);
//     //         alert('Error uploading course.');
//     //     }
//     // };

//     // const handleSubmit = async (e) => {
//     //     e.preventDefault();

//     //     // Custom document ID
//     //     const customDocId = '005';

//     //     const finalData = {
//     //         all_course_notes: formData.all_course_notes || "",
//     //         all_course_notes_link: formData.all_course_notes_link || "",
//     //         content_description: formData.content_description || "",
//     //         course_categories: formData.course_categories || "",
//     //         course_description: formData.course_description || "",
//     //         course_end_date: formData.course_end_date || new Date(),
//     //         course_expert_name: formData.course_expert_name || "",
//     //         course_id: customDocId,
//     //         course_image: formData.course_image || "",
//     //         course_language: formData.course_language || "Hindi/English",
//     //         course_length: formData.course_length || "",
//     //         course_name: formData.course_name || "",
//     //         course_price: {
//     //             actual_price: parseInt(formData.actual_price) || 0,
//     //             membership_price: parseInt(formData.membership_price) || 0
//     //         },
//     //         course_start_date: formData.course_start_date || new Date(),
//     //         course_tag: formData.course_categories || "",
//     //         course_type: formData.course_type || "",
//     //         created_date: new Date(),
//     //         demo_video_url: formData.demo_video_url || "",
//     //         expert_id: formData.expert_id || "",
//     //         expert_image_url: formData.expert_image_url || "",
//     //         is_certificate: formData.is_certificate || "no",
//     //         is_demo_video: formData.is_demo_video || "no",
//     //         is_doubt_clearing_session: formData.is_doubt_clearing_session || "no",
//     //         is_pdfnotes: formData.is_pdfnotes || "no",
//     //         is_quiz: formData.is_quiz || "false",
//     //         is_recording: formData.is_recording || "no",
//     //         is_whatsappgroup: formData.is_whatsappgroup || "no",
//     //         lessons: formData.lessons.map((lesson, index) => ({
//     //             lesson: lesson.lesson_data || "",
//     //             description: lesson.description || "",
//     //             video_link: lesson.video_link || "",
//     //             start_on: lesson.start_on ? new Date(lesson.start_on) : null,
//     //             end_on: lesson.end_on ? new Date(lesson.end_on) : null,
//     //             is_completed: "no",
//     //             is_file: lesson.is_file || "no",
//     //             is_online: lesson.is_online || "no",
//     //             is_video: lesson.is_video || "no",
//     //             notes: lesson.notes || "",
//     //             sequence: `${index + 1}`,
//     //             time: lesson.time || "",
//     //             title: lesson.title || "",
//     //             worksheet: lesson.worksheet || "",
//     //             zoom_date_time: lesson.zoom_date_time || "",
//     //             zoom_link: lesson.zoom_link || "",
//     //             completion_percentage: "0%",
//     //             timestamp: lesson.timestamps?.map(timestamp => ({
//     //                 time: timestamp.time || "",
//     //                 title: timestamp.title || "",
//     //             })) || []
//     //         })),
//     //         overall_completion_percentage: 0,
//     //         passing_marks: parseInt(formData.passing_marks) || 0,
//     //         quiz_id: formData.quiz_id || "",
//     //         registered_date: new Date(),
//     //         total_quiz_questions: parseInt(formData.total_quiz_questions) || 0,
//     //         updated_date: new Date()
//     //     };

//     //     try {
//     //         await setDoc(doc(db, 'nv_courses', customDocId), finalData);
//     //         alert(`Course uploaded successfully with ID: ${customDocId}`);
//     //     } catch (error) {
//     //         console.error("Error uploading course:", error);
//     //         alert('Error uploading course.');
//     //     }
//     // };





//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         try {
//             // Fetch existing documents from the 'nv_courses' collection
//             const querySnapshot = await getDocs(collection(db, 'nv_courses'));

//             // Determine the new document ID based on existing count
//             const docCount = querySnapshot.size;  // Get number of documents (currently 4)


//             // Extract numeric parts of document IDs

//             // Extract numeric parts of document IDs
//             const existingIds = querySnapshot.docs
//                 .map((doc) => parseInt(doc.id, 10)) // Convert IDs to numbers
//                 .filter((id) => !isNaN(id)) // Remove NaN values
//                 .sort((a, b) => a - b); // Sort in ascending order

//             // Find the first available ID in sequence
//             let nextDocId = 1; // Start from "001"
//             for (let id of existingIds) {
//                 if (id !== nextDocId) break; // Find first missing ID in sequence
//                 nextDocId++;
//             }

//             // Format as "003", "004", etc.
//             const formattedDocId = String(nextDocId).padStart(3, '0');

//             const finalData = {
//                 all_course_notes: formData.all_course_notes || "",
//                 all_course_notes_link: formData.all_course_notes_link || "",
//                 content_description: formData.content_description || "",
//                 course_categories: formData.course_categories || "",
//                 course_description: formData.course_description || "",
//                 course_end_date: formData.course_end_date || new Date(),
//                 course_expert_name: formData.course_expert_name || "",
//                 course_id: formattedDocId,
//                 course_image: formData.course_image || "",
//                 course_language: formData.course_language || "Hindi/English",
//                 course_length: formData.course_length || "",
//                 course_name: formData.course_name || "",
//                 course_price: {
//                     actual_price: parseInt(formData.actual_price) || 0,
//                     membership_price: parseInt(formData.membership_price) || 0
//                 },
//                 course_start_date: formData.course_start_date || new Date(),
//                 course_tag: formData.course_categories || "",
//                 course_type: formData.course_type || "",
//                 created_date: new Date(),
//                 demo_video_url: formData.demo_video_url || "",
//                 expert_id: formData.expert_id || "",
//                 expert_image_url: formData.expert_image_url || "",
//                 is_certificate: formData.is_certificate || "no",
//                 is_demo_video: formData.is_demo_video || "no",
//                 is_doubt_clearing_session: formData.is_doubt_clearing_session || "no",
//                 is_pdfnotes: formData.is_pdfnotes || "no",
//                 is_quiz: formData.is_quiz || "false",
//                 is_recording: formData.is_recording || "no",
//                 is_whatsappgroup: formData.is_whatsappgroup || "no",
//                 lessons: formData.lessons.map((lesson, index) => ({
//                     lesson: lesson.lesson_data || "",
//                     description: lesson.description || "",
//                     video_link: lesson.video_link || "",
//                     start_on: lesson.start_on ? new Date(lesson.start_on) : null,
//                     end_on: lesson.end_on ? new Date(lesson.end_on) : null,
//                     is_completed: "no",
//                     is_file: lesson.is_file || "no",
//                     is_online: lesson.is_online || "no",
//                     is_video: lesson.is_video || "no",
//                     notes: lesson.notes || "",
//                     sequence: `${index + 1}`,
//                     time: lesson.time || "",
//                     title: lesson.title || "",
//                     worksheet: lesson.worksheet || "",
//                     zoom_date_time: lesson.zoom_date_time || "",
//                     zoom_link: lesson.zoom_link || "",
//                     completion_percentage: "0%",
//                     timestamp: lesson.timestamps?.map(timestamp => ({
//                         time: timestamp.time || "",
//                         title: timestamp.title || "",
//                     })) || []
//                 })),
//                 overall_completion_percentage: 0,
//                 passing_marks: parseInt(formData.passing_marks) || 0,
//                 quiz_id: formData.quiz_id || "",
//                 registered_date: new Date(),
//                 total_quiz_questions: parseInt(formData.total_quiz_questions) || 0,
//                 updated_date: new Date()
//             };

//             // Save document with the custom generated ID
//             await setDoc(doc(db, 'nv_courses', formattedDocId), finalData);
//             console.log(formattedDocId)
//             console.log(finalData)

//             const response = await axios.post('http://localhost:5000/send-global-notification', {
//                 "title": "New Course Alert! Register Now!",
//                 "body": "A fresh course is here to help you level up! Register now and get started!",
//                 "image": formData.course_image, // Optional image URL,
//             });


//             alert(`Course uploaded successfully with ID: ${formattedDocId}`);
//         } catch (error) {
//             console.error("Error uploading course:", error);
//             alert('Error uploading course.');
//         }
//     };






//     return (
//         <>
//             <div class="p-2">
//                 <table className="table table-bordered table-hover">
//                     <thead className="thead-dark" style={{ position: "sticky", top: "0" }}>
//                         <tr>
//                             <th>Course ID</th>
//                             <th>Name</th>
//                             <th>Course Categories</th>
//                             <th>Course Type</th>
//                             <th>Start Date</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {courses.map(course => (
//                             <tr key={course.id}>
//                                 <td>{course.course_id}</td>
//                                 <td>{course.course_name}</td>
//                                 <td>{course.course_categories || "N/A"}</td>
//                                 <td>{course.course_type || "N/A"}</td>
//                                 <td>{course.course_start_date || "N/A"}</td>
//                             </tr>
//                         ))}
//                     </tbody>
//                 </table>
//             </div>
//             <div id="" class="m-3" style={{ border: "10px solid #344767" }}>
//                 <div class="w3layouts_payment_online_form">
//                     <h4>Upload Course</h4>
//                     <form onSubmit={handleSubmit}>

//                         <ul style={{ display: "flex" }}>
//                             <li><label>course_name</label><input class="w3l_text_box" name="course_name" placeholder="course_name" onChange={handleChange} /></li>
//                             <li><label>course_description</label><textarea rows="4" cols="50" class="w3l_text_box" name="course_description" placeholder="course_description" onChange={handleChange} /></li>
//                         </ul>

//                         <ul>
//                             <li><label>course image</label><input class="w3l_text_box" name="course_image" placeholder="Course Image URL" onChange={handleChange} /></li>
//                             <li><label>demo_video_url</label><input class="w3l_text_box" name="demo_video_url" placeholder="demo_video_url" onChange={handleChange} /></li>
//                         </ul>


//                         <ul>
//                             <li><label>actual_price</label><input class="w3l_text_box" name="actual_price" placeholder="actual_price" onChange={handleChange} /></li>
//                             <li><label>membership_price</label><input class="w3l_text_box" name="membership_price" placeholder="membership_price" onChange={handleChange} /></li>
//                         </ul>



//                         <ul>
//                             <li> <label>all_course_notes</label><select class="form-control" name="all_course_notes" onChange={handleChange} >
//                                 <option value="">-- All Course Notes --</option>
//                                 <option value="yes">yes</option>
//                                 <option value="no">no</option>
//                             </select></li>
//                             <li><label>all_course_notes_link</label><input class="w3l_text_box" name="all_course_notes_link" placeholder="all_course_notes_link" onChange={handleChange} /></li>
//                             {/* <li><label>course tag</label><input class="w3l_text_box" name="course_tag" placeholder="Course Tag" onChange={handleChange} /></li> */}

//                         </ul>

//                         <ul>
//                             <li> <label>course type</label><select class="form-control" name="course_type" onChange={handleChange} >
//                                 <option value="">-- course_type --</option>
//                                 <option value="Recorded">Recorded</option>
//                                 <option value="Live">Live</option>
//                             </select></li>

//                             <li><label>course length (eg. 1 hr 32 mins / 3 Days)</label><input class="w3l_text_box" name="course_length" placeholder="Course Length" onChange={handleChange} /></li>

//                         </ul>

//                         <ul>
//                             <li><label>Content Description (eg. 2 Recorded Classes/ 5 Live Classes) </label><input class="w3l_text_box" name="content_description" placeholder="content_description" onChange={handleChange} /></li>
//                             {/* <li><label>course_expert_name</label><input class="w3l_text_box" name="course_expert_name" placeholder="course_expert_name" onChange={handleChange} /></li>
//                          */}
//                             <li><label>course_expert_name</label>
//                                 <select className="form-control" name="course_expert_name" onChange={handleChange}>
//                                     <option value="">Select Expert Name</option>
//                                     {expert_name.map(({ name }) => (
//                                         <option key={name} value={name}>{`${name}`}</option>
//                                     ))}
//                                 </select>
//                             </li>
//                         </ul>






//                         <ul>

//                             <li><label>course_categories</label><input class="w3l_text_box" name="course_categories" placeholder="course_categories" onChange={handleChange} /></li>
//                         </ul>


//                         <ul>
//                             <li><label>Course Start Date (required)</label>
//                                 <input
//                                     type="date"
//                                     name="course_start_date"
//                                     onChange={handleChange}
//                                     required

//                                 /></li>
//                             <li><label>Course End Date (required)</label>
//                                 <input
//                                     type="date"
//                                     name="course_end_date"
//                                     onChange={handleChange}
//                                     required
//                                 /></li>
//                         </ul>



//                         <ul>
//                             {/* <li><label>course_id</label><input class="w3l_text_box" name="course_id" placeholder="course_id" onChange={handleChange} /></li> */}
//                             {/* <li><label>expert_id</label><input class="w3l_text_box" name="expert_id" placeholder="expert_id" onChange={handleChange} /></li>
//                          */}
//                             <li>
//                                 <label>expert_id</label>
//                                 <select className="form-control" name="expert_id" onChange={handleChange}>
//                                     <option value="">Select Expert ID</option>
//                                     {experts.map(({ id, name }) => (
//                                         <option key={id} value={id}>{`${id} - ${name}`}</option>
//                                     ))}
//                                 </select>
//                             </li>
//                             <li><label>expert_image_url</label>
//                                 <select className="form-control" name="expert_image_url" onChange={handleChange}>
//                                     <option value="">Select Expert Image</option>
//                                     {expert_image.map(({ profile_image, id, name }) => (
//                                         <option key={profile_image} value={profile_image}>{`${id} - ${name}`}</option>
//                                     ))}
//                                 </select>
//                                 {/* <input class="w3l_text_box" name="expert_image_url" placeholder="expert_image_url" onChange={handleChange} /> */}
//                             </li>
//                         </ul>


//                         <ul>
//                             <li> <label>is_certificate</label><select class="form-control" name="is_certificate" onChange={handleChange} >
//                                 <option value="">-- is_certificate --</option>
//                                 <option value="yes">yes</option>
//                                 <option value="no">no</option>
//                             </select></li>

//                             <li> <label>is_demo_video</label><select class="form-control" name="is_demo_video" onChange={handleChange} >
//                                 <option value="">-- is_demo_video --</option>
//                                 <option value="yes">yes</option>
//                                 <option value="no">no</option>
//                             </select></li>
//                         </ul>


//                         <ul>
//                             <li> <label>is_doubt_clearing_session</label><select class="form-control" name="is_doubt_clearing_session" onChange={handleChange} >
//                                 <option value="">-- is_doubt_clearing_session --</option>
//                                 <option value="yes">yes</option>
//                                 <option value="no">no</option>
//                             </select></li>

//                             <li> <label>is_pdfnotes</label><select class="form-control" name="is_pdfnotes" onChange={handleChange} >
//                                 <option value="">-- is_pdfnotes --</option>
//                                 <option value="yes">yes</option>
//                                 <option value="no">no</option>
//                             </select></li>
//                         </ul>


//                         <ul>
//                             <li> <label>is_recording</label><select class="form-control" name="is_recording" onChange={handleChange} >
//                                 <option value="">-- is_recording --</option>
//                                 <option value="yes">yes</option>
//                                 <option value="no">no</option>
//                             </select></li>

//                             <li> <label>is_whatsappgroup</label><select class="form-control" name="is_whatsappgroup" onChange={handleChange} >
//                                 <option value="">-- is_whatsappgroup --</option>
//                                 <option value="yes">yes</option>
//                                 <option value="no">no</option>
//                             </select></li>





//                         </ul>



//                         <ul>
//                             <li> <label>is_quiz</label><select class="form-control" name="is_quiz" onChange={handleChange} >
//                                 <option value="">-- is_quiz --</option>
//                                 <option value="true">true</option>
//                                 <option value="false">false</option>
//                             </select></li>

//                             <li><label>quiz_id</label><input class="w3l_text_box" name="quiz_id" placeholder="quiz_id" onChange={handleChange} /></li>

//                         </ul>

//                         <ul>
//                             <li><label>passing_marks</label><input class="w3l_text_box" name="passing_marks" type="number" placeholder="passing_marks" onChange={handleChange} /></li>
//                             <li><label>total_quiz_questions</label><input class="w3l_text_box" name="total_quiz_questions" placeholder="total_quiz_questions" onChange={handleChange} /></li>
//                             {/* <li><label>quiz_id</label><input class="w3l_text_box" name="quiz_id" placeholder="quiz_id" onChange={handleChange} /></li> */}
//                         </ul>





//                         <h4>Add Lessons</h4>
//                         {formData.lessons.map((lesson, lessonIndex) => (
//                             <div key={lessonIndex} style={{ marginBottom: "20px" }}>
//                                 {/* <label>Add Video File/module to upload</label> */}
//                                 {/* <input
//                                 type="file"
//                                 accept="video/*"
//                                 onChange={(e) => handleVideoUpload(lessonIndex, e.target.files[0])}
//                             />
//                             {lesson.video_link && <p>Video Uploaded: <a href={lesson.video_link} target="_blank" rel="noopener noreferrer">View Video</a></p>} */}
//                                 <ul>
//                                     {/* <li> <label>is_completed</label><select class="form-control" namde="is_completed" onChange={(e) => handleLessonChange(lessonIndex, e)} >
//                                     <option value="">-- is_completed --</option>
//                                     <option value="yes">yes</option>
//                                     <option value="no">no</option>
//                                 </select></li> */}

//                                     <li> <label>is_video</label><select class="form-control" name="is_video" onChange={(e) => handleLessonChange(lessonIndex, e)} >
//                                         <option value="">-- is_file --</option>
//                                         <option value="yes">yes</option>
//                                         <option value="no">no</option>
//                                     </select></li>
//                                     <li> <label>video_link/module (youtube ID)</label><input class="w3l_text_box" name="video_link" placeholder="video_link" onChange={(e) => handleLessonChange(lessonIndex, e)} /></li>
//                                 </ul>

//                                 <ul>
//                                     <li> <label>is_Live</label><select class="form-control" name="is_online" onChange={(e) => handleLessonChange(lessonIndex, e)} >
//                                         <option value="">-- is_live --</option>
//                                         <option value="yes">yes</option>
//                                         <option value="no">no</option>
//                                     </select></li>
//                                     <li><label>time (if Live)</label><input class="w3l_text_box" name="time" placeholder="time" onChange={(e) => handleLessonChange(lessonIndex, e)} /></li>
//                                 </ul>


//                                 <ul>
//                                     <li><label>zoom_date_time (if live)</label><input class="w3l_text_box" name="zoom_date_time" placeholder="zoom_date_time" onChange={(e) => handleLessonChange(lessonIndex, e)} /></li>
//                                     <li><label>zoom_link (if Live)</label><input class="w3l_text_box" name="zoom_link" placeholder="zoom_link" onChange={(e) => handleLessonChange(lessonIndex, e)} /></li>
//                                 </ul>


//                                 {/*
//                             <input
//                                 name="lesson"
//                                 placeholder="Lesson Name"
//                                 onChange={(e) => handleLessonChange(lessonIndex, e)}

//                             /> */}

//                                 <ul>
//                                     <li>  <label>Lesson/Module Name</label>
//                                         <input class="w3l_text_box" name="lesson_data" placeholder="lesson" onChange={(e) => handleLessonChange(lessonIndex, e)} /></li>
//                                     <li><label>title</label><input class="w3l_text_box" name="title" placeholder="title" onChange={(e) => handleLessonChange(lessonIndex, e)} /></li>
//                                 </ul>

//                                 {/* <input
//                                 name="description"
//                                 placeholder="Lesson Description"
//                                 onChange={(e) => handleLessonChange(lessonIndex, e)}

//                             /> */}
//                                 <label>Description</label>
//                                 <input class="w3l_text_box" name="description" placeholder="description" onChange={(e) => handleLessonChange(lessonIndex, e)} />






//                                 <ul>
//                                     <li>
//                                         <label>Starts on (if Live)</label>
//                                         <input
//                                             type="datetime-local"
//                                             name="start_on"
//                                             onChange={(e) => handleLessonChange(lessonIndex, e)}
//                                         />
//                                     </li>
//                                     <li>
//                                         <label>Ends on (if Live)</label>
//                                         <input
//                                             type="datetime-local"
//                                             name="end_on"
//                                             onChange={(e) => handleLessonChange(lessonIndex, e)}
//                                         />
//                                     </li>
//                                 </ul>






//                                 <ul>
//                                     <li><label>notes drive link</label><input class="w3l_text_box" name="notes" placeholder="notes drive link" onChange={(e) => handleLessonChange(lessonIndex, e)} /></li>
//                                     <li><label>worksheet (drive link)</label><input class="w3l_text_box" name="worksheet" placeholder="worksheet" onChange={(e) => handleLessonChange(lessonIndex, e)} /></li>
//                                     {/* <li><label>sequence {lessonIndex}</label><input class="w3l_text_box" name="sequence" placeholder="sequence" onChange={(e) => handleLessonChange(lessonIndex, e)} /></li> */}
//                                 </ul>

//                                 <ul>
//                                     {/* <li><label>time (if Live)</label><input class="w3l_text_box" name="time" placeholder="time" onChange={(e) => handleLessonChange(lessonIndex, e)} /></li> */}
//                                     {/* <li><label>title</label><input class="w3l_text_box" name="title" placeholder="title" onChange={(e) => handleLessonChange(lessonIndex, e)} /></li> */}
//                                 </ul>

//                                 <ul>
//                                     {/* <li><label>video_ID (same as uploading in workshop recorded video id)</label><input class="w3l_text_box" name="video_link" placeholder="video_link" onChange={(e) => handleLessonChange(lessonIndex, e)} /></li> */}

//                                 </ul>



//                                 {/* <ul>
//                                 <li><label>completion_percentage (always set as "0%")</label><input class="w3l_text_box" name="completion_percentage" placeholder="completion_percentage" onChange={(e) => handleLessonChange(lessonIndex, e)} /></li>
//                             </ul> */}





//                                 <button class="w3_payment_sendbtns" type="button" onClick={() => addTimestamp(lessonIndex)}>Add Timestamp</button>
//                                 {lesson.timestamps.map((timestamp, timestampIndex) => (
//                                     <div key={timestampIndex} style={{ marginBottom: "10px" }}>
//                                         <ul>
//                                             <li>  <input
//                                                 name="time"
//                                                 placeholder="Time"
//                                                 onChange={(e) => handleTimestampChange(lessonIndex, timestampIndex, e)}

//                                             /></li>
//                                             <li> <input
//                                                 name="title"
//                                                 placeholder="Title"
//                                                 onChange={(e) => handleTimestampChange(lessonIndex, timestampIndex, e)}

//                                             /></li>
//                                         </ul>


//                                     </div>
//                                 ))}

//                                 <hr
//                                     style={{
//                                         backgroundColor: "red",
//                                         height: 5
//                                     }}
//                                 />
//                             </div>
//                         ))}
//                         <button class="btn btn-warning mr-4" type="button" onClick={addLesson}>Add Lesson</button>


//                         <button class="btn btn-primary" type="submit">Upload Course</button>
//                     </form>
//                 </div>
//             </div>
//         </>
//     );
// };

// export default CourseUploadForm;


// // import React, { useState } from "react";
// // import { addDoc, collection, serverTimestamp } from "firebase/firestore";
// // import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";
// // import db, { storage } from "./Firebase";

// // const CourseUploadForm = () => {
// //     const [formData, setFormData] = useState({
// //         course_name: '',
// //         course_description: '',
// //         course_duration: '',
// //         course_price_actual: '',
// //         course_price_membership: '',
// //         course_image: '',
// //         lessons: [],
// //     });

// //     const handleChange = (e) => {
// //         const { name, value } = e.target;
// //         setFormData((prev) => ({
// //             ...prev,
// //             [name]: value,
// //         }));
// //     };

// //     const addLesson = () => {
// //         setFormData((prev) => ({
// //             ...prev,
// //             lessons: [...prev.lessons, { lesson: '', description: '', timestamps: [] }],
// //         }));
// //     };

// //     const handleLessonChange = (index, e) => {
// //         const { name, value } = e.target;
// //         const updatedLessons = [...formData.lessons];
// //         updatedLessons[index][name] = value;
// //         setFormData((prev) => ({ ...prev, lessons: updatedLessons }));
// //     };

// //     const addTimestamp = (lessonIndex) => {
// //         const updatedLessons = [...formData.lessons];
// //         updatedLessons[lessonIndex].timestamps.push({ time: '', title: '' });
// //         setFormData((prev) => ({ ...prev, lessons: updatedLessons }));
// //     };

// //     const handleTimestampChange = (lessonIndex, timestampIndex, e) => {
// //         const { name, value } = e.target;
// //         const updatedLessons = [...formData.lessons];
// //         updatedLessons[lessonIndex].timestamps[timestampIndex][name] = value;
// //         setFormData((prev) => ({ ...prev, lessons: updatedLessons }));
// //     };

// //     const handleSubmit = async (e) => {
// //         e.preventDefault();
// //         // try {
// //         //     await addDoc(collection(db, 'nv_courses'), formData);
// //         //     alert('Course uploaded successfully!');
// //         // } catch (error) {
// //         //     console.error('Error uploading course:', error);
// //         // }
// //         console.log(formData);
// //     };

// //     return (
// //         <div>
// //             <h2>Upload Course</h2>
// //             <form onSubmit={handleSubmit}>
// //                 <input name="course_name" placeholder="Course Name" onChange={handleChange} required />
// //                 <input name="course_description" placeholder="Course Description" onChange={handleChange} required />
// //                 <input name="course_duration" placeholder="Course Duration" onChange={handleChange} required />
// //                 <input name="course_price_actual" placeholder="Actual Price" type="number" onChange={handleChange} required />
// //                 <input name="course_price_membership" placeholder="Membership Price" type="number" onChange={handleChange} required />
// //                 <input name="course_image" placeholder="Course Image URL" onChange={handleChange} required />

// //                 <h3>Lessons</h3>
// //                 {formData.lessons.map((lesson, lessonIndex) => (
// //                     <div key={lessonIndex}>
// //                         <input
// //                             name="lesson"
// //                             placeholder="Lesson Name"
// //                             onChange={(e) => handleLessonChange(lessonIndex, e)}
// //                             required
// //                         />
// //                         <input
// //                             name="description"
// //                             placeholder="Lesson Description"
// //                             onChange={(e) => handleLessonChange(lessonIndex, e)}
// //                             required
// //                         />
// //                         <button type="button" onClick={() => addTimestamp(lessonIndex)}>Add Timestamp</button>
// //                         {lesson.timestamps.map((timestamp, timestampIndex) => (
// //                             <div key={timestampIndex}>
// //                                 <input
// //                                     name="time"
// //                                     placeholder="Time"
// //                                     onChange={(e) => handleTimestampChange(lessonIndex, timestampIndex, e)}
// //                                     required
// //                                 />
// //                                 <input
// //                                     name="title"
// //                                     placeholder="Title"
// //                                     onChange={(e) => handleTimestampChange(lessonIndex, timestampIndex, e)}
// //                                     required
// //                                 />
// //                             </div>
// //                         ))}
// //                     </div>
// //                 ))}
// //                 <button type="button" onClick={addLesson}>Add Lesson</button>
// //                 <button type="submit">Upload Course</button>
// //             </form>
// //         </div>
// //     );
// // };

// // export default CourseUploadForm;
